import { render, staticRenderFns } from "./ModalDeleteToDo.vue?vue&type=template&id=4908a570"
import script from "./ModalDeleteToDo.vue?vue&type=script&lang=js"
export * from "./ModalDeleteToDo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports